import { useAuthStore } from '~/store/auth.store';

import { useTenantSwitch } from './useTenantSwitch';

/**
 * The shell's "jump to the Lily AI system tenant" action, for screens that are
 * managed from there (file transformers). Same `useTenantSwitch` call the copilot
 * shell's quick-switch makes; `redirectTo` lands the reload on a deep link.
 */
export function useSwitchToSystemTenant() {
  const { switchTenant, isSwitching, canSwitch } = useTenantSwitch();
  const systemTenant = useAuthStore((s) => s.user?.accessibleTenants.find((t) => t.isSystem));

  return {
    systemTenant,
    isSwitching,
    canSwitch: canSwitch && systemTenant !== undefined,
    switchToSystem: (redirectTo?: string) => {
      if (!systemTenant) return Promise.resolve(false);
      return switchTenant(systemTenant.id, redirectTo ? { redirectTo } : undefined);
    },
  };
}
